export default __webpack_public_path__ + "static/media/네오 스마트 플래너 2022 M Basic.148ca18f.png";